import React from 'react'
import styled from 'styled-components';
import { State } from '@hookstate/core';
import { Validation, ValidationError } from '@hookstate/validation';
import { useLanguageState } from '../../globalStates/LanguageState';
import RadioField from '../../components/Field/Radio';

const LanguageSwitchWrapper = styled.div`
    & > .form-check .form-check-label {
        white-space: nowrap;
    }
    & > .form-check > .invalid-feedback {
        margin-top: 0;
        margin-left: 0.25rem;
    }
`

function hasError(lang: string, validationError: ValidationError) {
    const fieldName = validationError.path ? validationError.path[validationError.path.length - 1] as string : ''
    if (lang === 'En') {
        return !fieldName.endsWith('De')
    }
    return fieldName.endsWith(lang)
}

function hasErrors(lang: string, entityState?: State<any>) {
    if (entityState) {
        const validationErrors = Validation(entityState).errors()
        // console.log(validationErrors)
        return validationErrors.some((validationError) => hasError(lang, validationError))
    }
    return false
}

interface LanguageSwitchProps {
    id?: string
    name: string
    value: string
    onChange: (language: string) => void
    entityState?: State<any>
}

const LanguageSwitch: React.FC<LanguageSwitchProps> = ({ id, name, value, onChange, entityState }) => {
    const branding = useLanguageState().getStrings()
    const isInvalidEn = hasErrors('En', entityState)
    const isInvalidDe = hasErrors('De', entityState)
    const isMonoLingual = branding.configuration.monoLingual;

    return (
        <LanguageSwitchWrapper className="form-check-inline mb-5">
            <RadioField
                id={`${id}_De`}
                name={name}
                value={value}
                radioValue="De"
                isInvalid={isInvalidDe}
                label={branding.configuration.languageSwitch.lblGermanOption}
                onChange={onChange}
            />
            <RadioField
                id={`${id}_En`}
                name={name}
                value={value}
                radioValue="En"
                isInvalid={isInvalidEn}
                label={branding.configuration.languageSwitch.lblEnglishOption}
                onChange={onChange}
                disabled={isMonoLingual}
            />
        </LanguageSwitchWrapper>
    )
}

export default LanguageSwitch